import { WorkloadRecommendationStatusTypeEnum } from '@cast/types';

import { STATUS_BADGE_COLOR_MAP } from '../../../_constants';

import { tokens } from '@cast/design-system';

export const CLICKABLE_STATUS_BADGE_COLOR_MAP = {
  [WorkloadRecommendationStatusTypeEnum.APPLIED]: {
    ...STATUS_BADGE_COLOR_MAP[WorkloadRecommendationStatusTypeEnum.APPLIED],
    border: '1px solid transparent',
    transition: 'background-color 0.3s ease, color 0.3s ease',

    '&:hover': {
      bgcolor: tokens.theme.bg.status.successSubtle,
      color: tokens.theme.fg.status.onSuccessSubtle,
    },

    '&:active': {
      bgcolor: tokens.theme.bg.status.successSubtle,
      color: tokens.theme.fg.status.success,
      borderColor: tokens.theme.border.status.successSubtle,
    },
  },
  [WorkloadRecommendationStatusTypeEnum.STOPPED]: {
    ...STATUS_BADGE_COLOR_MAP[WorkloadRecommendationStatusTypeEnum.STOPPED],
    border: '1px solid transparent',
    transition: 'background-color 0.3s ease, color 0.3s ease',
  },
} as const;

export const AMOUNT_OF_PODS_IN_TOOLTIP = 4;
